import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import InstallPrompt from "@/components/InstallPrompt";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import RoutesList from "@/pages/RoutesList";
import ImportRoute from "@/pages/ImportRoute";
import Analysis from "@/pages/Analysis";
import Fleet from "@/pages/Fleet";
import Admin from "@/pages/Admin";
import DriverHome from "@/pages/DriverHome";
import DriverRoute from "@/pages/DriverRoute";
import History from "@/pages/History";

function RootRedirect() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "driver" ? "/driver" : "/dashboard"} replace />;
}

const Dispatch = ({ children }) => (
  <ProtectedRoute roles={["super_admin", "owner", "admin", "dispatch"]}><Layout>{children}</Layout></ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <InstallPrompt />
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />

            <Route path="/dashboard" element={<Dispatch><Dashboard /></Dispatch>} />
            <Route path="/routes" element={<Dispatch><RoutesList /></Dispatch>} />
            <Route path="/routes/import" element={<Dispatch><ImportRoute /></Dispatch>} />
            <Route path="/routes/:id/analyze" element={<Dispatch><Analysis /></Dispatch>} />
            <Route path="/fleet" element={<Dispatch><Fleet /></Dispatch>} />
            <Route path="/history" element={<Dispatch><History /></Dispatch>} />
            <Route path="/admin" element={<ProtectedRoute roles={["super_admin", "owner", "admin"]}><Layout><Admin /></Layout></ProtectedRoute>} />

            <Route path="/driver" element={<ProtectedRoute roles={["super_admin", "owner", "admin", "dispatch", "driver"]}><DriverHome /></ProtectedRoute>} />
            <Route path="/driver/:assignmentId" element={<ProtectedRoute roles={["super_admin", "owner", "admin", "dispatch", "driver"]}><DriverRoute /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
